
<template>

  <div class="children-container">
    <div class="children-module-name"><span>{{ title }}</span></div>
    <div class="children-module-content" style="background-color: transparent;padding: 0!important;padding: 0 !important;">
      <div style="background-color: #fff;padding: 25px 25px 10px 25px;margin-bottom: 20px;">
        <a-form-model layout="inline">
          <a-form-model-item>
            <a-input placeholder="请输入订单号" v-model="page.order_id" size="small"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-select style="width: 150px" placeholder="请选择订单状态" v-model="page.state" :clearable="true">
              <a-select-option value="TOBEPAID">
                待支付
              </a-select-option>
              <a-select-option value="PRODUCTION">
                生产中
              </a-select-option>
              <a-select-option value="RECEIVED">
                待收货
              </a-select-option>
              <a-select-option value="EVALUATED">
                待评价
              </a-select-option>
              <a-select-option value="OVER">
                已完成
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select style="width: 150px" placeholder="请选择支付状态" v-model="page.pay_state" :clearable="true">
              <a-select-option value="TRUE">
                已支付
              </a-select-option>
              <a-select-option value="FALSE">
                未支付
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="下单时间" >
            <a-range-picker @change="changeTime"  style="width: 200px"/>
          </a-form-model-item>
        </a-form-model>
        <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px;">
          <a-form-model-item>
            <a-button class="cu-btn" type="primary" @click="search">搜索</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="resetForm" class="cu-btn" style="margin: 0 15px;border: 1px solid #008276;color: #008276;">重置</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <!-- <a-button class="cu-btn" style="background-color: #e6f2f2;color: #008276;border: 1px solid #e6f2f2;">导出订单</a-button> -->
          </a-form-model-item>
        </div>
      </div>

      <div v-if="list.length == 0 && flag == true" style="display: flex;justify-content: center;align-items: center;flex-direction: column;padding: 40px 0;background: #fff">
        <img src="https://jc-yk-static.oss-cn-shanghai.aliyuncs.com/icons/nodata.png" alt="" style="width: 200px">
        <span style="margin-top: 10px;color: #666666;padding-right: 20px">暂无数据</span>
      </div>
      <div v-else>
        <div v-for="(item, index) in list" :key="index" class="product-list" style="background-color: #fff;padding: 20px 25px;font-size: 12px;margin-bottom: 20px;border-radius: 4px;">
          <div style="margin-bottom:10px;font-weight:600;color:rgb(0, 130, 118)"><span>订单流水号: </span><span>{{item.order_id}}</span><span style="font-weight: 600;margin-left: 20px;color: #666">下单时间: </span><span style="color: #666">{{item.create_time}}</span></div>
          <div v-for="(good, index) in item.good_list" :key="index" style="padding-top: 10px;position: relative;">
            <!-- <div v-if="item.type == 'NORMAL'" style="margin-bottom:10px;font-weight:600;color:rgb(0, 130, 118)"><span>订单流水号: </span><span>{{item.order_id}}</span></div> -->
            <div style="display: flex;align-items: center;">
              <div><span>{{good.strain_number}}</span></div>
              <div style="margin: 0 20px;"><span>{{good.common_name}}</span></div>
              <div><span v-html="good.strain_name"></span></div>
            </div>
            <div style="border-bottom: 1px solid #eee;">
              <div style="display: flex;align-items: center;padding: 10px 0;">
                <div style="margin-right: 20px;"><span style="font-weight: 600;">基因型: </span><span style="color: #008276;">{{good.gene}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">周龄: </span><span style="color: #008276;">{{good.wks}}</span></div>
                <div style="margin-right: 20px;">
                  <span style="font-weight: 600;">性别: </span>
                  <span style="color: #ff6ec7 !important;" v-if="good.sex.indexOf('雌') != -1">{{ good.sex }}</span>
                  <span style="color: #0000ff !important;" v-else-if="good.sex.indexOf('雄') != -1">{{ good.sex }}</span>
                  <span v-else>{{ good.sex }}</span>
                </div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">数量: </span><span style="color: #008276;">{{good.num}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">小计: </span><span style="color: #008276;">{{good.price | fmtPrice3}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">到货时间: </span><span style="color: #008276;">{{good.delivery_time}}</span></div>
                <div><a-button v-if="good.salesAfter == true" @click="openSalesAfter(item, good)" type="dashed" size="small"><a-icon type="frown" style="color: #ff4d4f" /><span style="color: #ff4d4f">申请售后</span></a-button></div>
              </div>
<!--              <div style="display: flex;padding: 0px 0 10px 0;">-->
<!--                <div style="margin-right: 10px;"><span>运输方式: </span><span style="color: #008276;">{{item.transport_name}}</span></div>-->
<!--                <div style="margin-right: 10px;"><span>包装方式: </span><span style="color: #008276;">{{item.pack_name}}</span></div>-->
<!--                <div style="margin-right: 10px;"><span>包装信息: </span><span style="color: #008276;">{{good.ruleInfo}}</span></div>-->
<!--                <div style="margin-right: 10px;"><span>到货时间: </span><span style="color: #008276;">{{good.delivery_time}}</span></div>-->
<!--              </div>-->
            </div>
            <div style="border-bottom: 1px solid #eee;" v-if="item.files !=null" :ref="item.id" :id="item.id">
              <div>
                <div style="font-weight: bold;padding-top: 5px;margin-bottom: 5px">
                  相关文件列表
                </div>
                <div class="file-list" v-for="f in item.files" >
                  <a :href="f.name" download="" target="_blank">{{ f.name }}(点击查看)</a>
                </div>
              </div>
              <div class="bb" style="margin-top: 10px;padding-bottom: 5px">
                <span style="font-weight: bold">状态: </span>
                <span v-if="item.file_state == 'TRUE'">客户已确认</span>
                <span v-if="item.file_state == 'FALSE'">客户未确认</span>
                <a-button  v-if="item.file_state == 'FALSE'" @click="fileConfirmation(item)" type="primary" size="small" style="margin-left: 10px;height: 26px"><a-icon type="check-circle" /> 点击确认</a-button>
              </div>
            </div>

          </div>
<!--          <div>-->
<!--            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">下单时间: </span><span>{{item.create_time}}</span></div>-->
<!--          </div>-->
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">收货地址: </span><span>{{item.address_json.province_name}}{{item.address_json.city_name}}{{item.address_json.area_name}}{{item.address_json.info}}({{item.name}} {{item.mobile}})</span></div>
          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">开票信息: </span>
              <span v-if="item.bill.type == 0">开票类型：发票随鼠</span>
              <span v-if="item.bill.type == 1">开票类型：普通发票</span>
              <span v-if="item.bill.type == 2">开票类型：拆票</span>
              <span v-if="item.bill.type == 4">开票类型：月结</span>
              <span v-if="item.bill.type == 5">开票类型：预付款</span>
              <span style="margin: 0 20px">单位名称：{{item.bill.name}}</span><span>纳税人识别号：{{item.bill.tax_number}}</span></div>
          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">下单帐户: </span>
              <span>{{item.account.name}}</span>
              <span style="margin: 0 10px;">PI姓名: {{item.account.pi_name}}</span>
            </div>
          </div>
          <div style="display: flex;">
            <div style="padding: 10px 0 0 0 ;">
              <span style="font-weight: 600;">运费: </span>
              <span>{{item.freight}}</span>
            </div>
            <div style="padding: 10px 0 0 0 ;margin: 0 10px;">
              <span style="font-weight: 600;">包装费: </span>
              <span>{{item.packaging_fee}}</span>
            </div>
            <div style="padding: 10px 0 0 0 ;">
              <span style="font-weight: 600;">总金额: </span>
              <span style="font-weight: bold">{{item.total_price}}</span>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end">
            <a-button class="ml10" @click="openLookOutbound(item.id)" type="primary" v-if="item.state == 'EVALUATED' || item.state == 'RECEIVED' || item.state == 'OVER'" size="small"><a-icon type="eye" />查看出库单</a-button>
            <a-button class="ml10" @click="openHealthReport(item.id)" type="primary" v-if="item.state == 'EVALUATED' || item.state == 'RECEIVED' || item.state == 'OVER'" size="small"><a-icon type="eye" />查看健康报告</a-button>
            <a-button class="ml10" v-if="item.type == 'NORMAL' && is_sale == 'FALSE'" @click="againOrder(item)" type="primary" size="small"><a-icon type="copy" /> 再来一单</a-button>
            <a-button class="ml10" v-if="item.type == 'COMBINATION' && is_sale == 'FALSE'" @click="againOrderC(item)" type="primary" size="small"><a-icon type="copy" /> 再来一单</a-button>
            <a-button class="ml10" @click="alipayThenPay(item.id)" type="primary" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID' && item.pay_type == 'ALIPAY' && is_sale == 'FALSE'" size="small"><a-icon type="alipay" /> 去付款</a-button>
            <a-button class="ml10" @click="wxThenPay(item.id)" type="primary" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID' && item.pay_type == 'WECHAT' && is_sale == 'FALSE'" size="small"><a-icon type="wechat" /> 去付款</a-button>
            <a-button class="ml10" @click="openCancel(item.id)" type="danger" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID' && is_sale == 'FALSE'" size="small"><a-icon type="close-circle" /> 取消订单</a-button>
            <a-button class="ml10" @click="openProgress(item.id)" type="primary" size="small"><a-icon type="unordered-list" /> 项目进展</a-button>
            <a-button class="ml10" @click="openDetail(item.id)" type="primary" size="small"><a-icon type="eye" /> 订单详情</a-button>
          </div>
        </div>

      </div>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow" v-model="page.start"
                      @change="changePage" />
      </div>
      <a-modal dialogClass="custom-dialog" :width="250" :maskClosable="false" v-model="wxQrVisible" title="微信支付二维码"
               @cancel="wxPay('cancel')"
               @ok="wxPay('ok')" :destroyOnClose="true" :disabled="$store.state.requestLoading" okText="我已完成支付">
        <div id="qrcode"></div>
      </a-modal>
      <a-modal dialogClass="custom-dialog" :width="800" :maskClosable="false" v-model="healthReportVisible" title="健康报告列表"
               :destroyOnClose="true" :footer="null">
          <a-table :columns="healthReportColumns" :data-source="healthReportList">
            <a slot="name" slot-scope="text" download="" :href="text" target="_blank">{{ text }}</a>
          </a-table>

      </a-modal>

      <a-modal dialogClass="custom-dialog" :width="1200" :maskClosable="false" v-model="lookOutboundVisible" title="出库单"
               :destroyOnClose="true" :footer="null">

        <div class="t-box" v-for="(item, index) in lookOutboundList">
          <div class="title">江苏集萃药康生物科技股份有限公司小鼠费用清单（出库单）</div>
          <div class="order-box">
            <span>订单号：{{item.documentManageVos[0].orderNumber}}     </span>
            <span style="margin: 0 20px">销货号：{{ item.documentManageVos[0].number }}     </span>
            <span>合同号：</span>
          </div>
          <table style="width: 100%" class="good-table">
            <tr class="column-box">
              <td style="width: 100px">编号</td>
              <td style="width: 100px">品系</td>
              <td style="width: 100px">基因型</td>
              <td style="width: 100px">性别</td>
              <td style="width: 100px">年龄</td>
              <td style="width: 100px">赠送</td>
              <td style="width: 100px">发货数量</td>
              <td style="width: 100px">报损数量</td>
              <td style="width: 100px">单价</td>
              <td style="width: 100px">总价</td>
              <td style="width: 100px">总额</td>
            </tr>
            <tr class="content-box" v-for="(item1, index1) in item.documentManageVos">
              <td>{{item1.strainNumber}}</td>
              <td>{{item1.strainName}}</td>
              <td>{{item1.genotypesName}}</td>
              <td>{{item1.sex}}</td>
              <td>{{item1.endAge}}周</td>
              <td><span v-if="item.isGift == 0">是</span><span v-else>否</span></td>
              <td>{{item1.quantity}}</td>
              <td>{{item1.lossQuantity}}</td>
              <td>{{item1.micePrice}}</td>
              <td>{{item1.dprice}}</td>
              <td>{{item1.dprice}}</td>
            </tr>
            <tr class="content-box">
              <td colspan="8"></td>
              <td>小计</td>
              <td>{{item.dtotal}}</td>
              <td>{{item.dtotal}}</td>
            </tr>
            <tr class="content-box">
              <td style="font-weight: bold">支付方式</td>
              <td colspan="5" style="text-align: left">{{item.documentManageVos[0]['payId']}}</td>
              <td style="font-weight: bold">津贴</td>
              <td style="text-align: left">{{item.documentManageVos[0]['jintie']}}</td>
              <td style="font-weight: bold">总额合计</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['totalAmount']}}</td>
            </tr>
            <tr class="content-box">
              <td style="font-weight: bold">联系人单位</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['unit']}}</td>
              <td style="font-weight: bold">责任人</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['principal']}}</td>
              <td style="font-weight: bold">联系人名称</td>
              <td style="text-align: left">{{item.documentManageVos[0]['customer']}}</td>
              <td style="font-weight: bold">联系人电话</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['phone']}}</td>
            </tr>
            <tr class="content-box">
              <td style="font-weight: bold">运输方式</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['shipMethodId']}}</td>
              <td style="font-weight: bold">取鼠人签字</td>
              <td colspan="2" style="text-align: left"></td>
              <td style="font-weight: bold">包鼠日期</td>
              <td style="text-align: left">{{item.documentManageVos[0]['shipDate']}}</td>
              <td style="font-weight: bold">制单人</td>
              <td colspan="2" style="text-align: left">{{item.documentManageVos[0]['preparedBy']}}</td>
            </tr>
            <tr class="content-box">
              <td style="font-weight: bold">备注说明</td>
              <td colspan="9" style="text-align: left">
                <div style="line-height: 26px;padding-left: 35px">尊敬的客户您好！</div>
                <div style="line-height: 26px;padding-left: 20px">1. 确认签收前，请您仔细查验，如收到的小鼠与实际要求不符的，请您联系服务项目经理处理争议。</div>
                <div style="line-height: 26px;padding-left: 20px">2. 未经药康书面授权，任何主体不得获取小鼠后裔、衍生品系或衍生产物以用于商业用途，否则产生的全部收入归药康所有。</div>
                <div style="line-height: 26px;padding-left: 20px">3. 请您签收后及时支付相应款项。</div>
                <div style="line-height: 26px;padding-left: 35px">期待为您再次服务。</div>
              </td>
            </tr>
          </table>
        </div>
      </a-modal>
      <a-drawer
          title="项目进展"
          placement="right"
          :closable="true"
          :visible="visibleProgress"
          @close="closeProgress"
          width="300"
      >
        <a-timeline >
          <a-timeline-item v-for="(item, index) in progressList" :key="index">
            <p style="display: flex;flex-direction: column; color: #000000" :class="index == 0 ? '' : 'default'">
              <span style="font-size: 12px">{{item.create_time}}</span>
              <span style="font-size: 12px">{{item.content}}</span>
            </p>
          </a-timeline-item>
        </a-timeline>

      </a-drawer>
      <!--  详情-->
      <a-drawer
          title="订单详情"
          :width="780"
          placement="right"
          :closable="true"
          :visible="detailVisible"
          @close="closeDetail"
      >
        <div class="detail-container" v-if="detailData != null">
          <div class="detail-container-left">
            <div class="label-item" style="border-bottom: none">
              <span class="label-title">订单号：</span>
              <span class="label-info">{{ detailData.mallorder_id }}</span>
            </div>
            <div class="item-block mt10" style="margin-bottom: 10px">
              <div class="item-block-title">客户信息</div>
              <div>
                <div class="label-item">
                  <span class="label-title">客户单位：</span>
                  <span class="label-info">{{ detailData.account.name }}</span>
                </div>
                <div class="label-item bb">
                  <span class="label-title">PI姓名：</span>
                  <span class="label-info ">{{ detailData.account.pi_name }}</span>
                  <span class="label-title ml20">PI手机号：</span>
                  <span class="label-info">{{ detailData.account.pi_mobile }}</span>
                  <span class="label-title ml20">PI邮箱：</span>
                  <span class="label-info">{{ detailData.account.pi_mail }}</span>
                  <!--                <span class="label-info" v-if="detailData.account.pi_name == '数据暂未同步' && detailData.state == 'TOBEPAID'"><a-button style="margin-left: 20px" @click="openSyncPiUnit" type="primary"><i-->
                  <!--                    class="fas fa-edit"></i>同步PI与单位</a-button></span>-->
                </div>
                <div class="label-item" style="border-bottom: none">
                  <span class="label-title">联系人姓名：</span>
                  <span class="label-info">{{ detailData.account.lxr_name }}</span>
                  <span class="label-title ml20">联系人手机号：</span>
                  <span class="label-info">{{ detailData.account.lxr_mobile }}</span>
                  <span class="label-title ml20">联系人邮箱：</span>
                  <span class="label-info">{{ detailData.account.lxr_mail }}</span>
                </div>
              </div>
            </div>
            <a-table size="small" :rowKey="(record, index) => index" :pagination="false" class="w-full cu-table"
                     :columns="detailColumns" :data-source="detailData.good_list">
              <template slot="gene" slot-scope="text, record">
                <span v-html="text"></span>
              </template>
              <template slot="isPresent" slot-scope="text, record">
                <span v-if="text == true"><a-icon type="check" style="font-weight: bold" /></span>
              </template>
              <template slot="wks" slot-scope="text, record">
                <span v-if="record && record.age_min">{{record.age_min}} - {{record.age_max}}周龄</span>
                <span v-else="record && record.age_min">{{text}}</span>
              </template>
              <!--            <template #id="{text, record, index}">-->
              <!--              <a-checkbox v-if="detailData.state == 'TOBEPAID' && detailData.good_list.length > 1"-->
              <!--                          :checked="isSelect(index)" @change="selectGoods($event, index)"></a-checkbox>-->
              <!--            </template>-->
              <!--            <template #delivery_time="{text, record, index}">-->
              <!--              <span>{{text}}</span>-->
              <!--              <p @click="openChangeDeliveryTime(index)" style="color: #00a0e9;cursor: pointer" v-if="detailData.state == 'TOBEPAID'" type="link">(修改)</p>-->
              <!--            </template>-->

            </a-table>
            <div class="label-item mt10" style="padding-bottom: 10px">
              <span class="label-title">订单备注：</span>
              <span class="label-info">{{ detailData.content }}</span>
            </div>
            <a-table size="small" :rowKey="(record, index) => index" :pagination="false" class="w-full cu-table"
                     :columns="infoColumns" :data-source="info_list">
              <template slot="pay_type" slot-scope="text, record">
                <span v-if="text == 'WECHAT'">微信支付</span>
                <span v-if="text == 'ALIPAY'">支付宝</span>
                <span v-if="text == 'OFFLINE'">线下支付</span>
              </template>
              <template slot="total_price" slot-scope="text, record">
                <span style="font-weight: bold">{{ text }}</span>
              </template>
            </a-table>
            <div class="item-block mt10">
              <div class="item-block-title">收货信息</div>
              <div>
                <div class="label-item bb">
                  <span class="label-title">联系人：</span>
                  <span class="label-info">{{ detailData.address_json.name }} - {{detailData.other_contact}}</span>
                  <span class="label-title ml20">联系电话：</span>
                  <span class="label-info">{{ detailData.address_json.mobile }}</span>
                </div>
                <div class="label-item bb">
                  <span class="label-title">收货地址：</span>
                  <span class="label-info">{{ detailData.address_json.province_name }}{{
                      detailData.address_json.city_name
                    }}{{ detailData.address_json.area_name }}{{ detailData.address_json.info }}</span>
                </div>
                <div class="label-item bb" style="border-bottom: none">
                  <span class="label-title">实验动物使用许可证号：</span>

                  <span class="label-info">{{ detailData.license.faren_name }} - {{ detailData.license.license_key }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-drawer>
      <!-- 售后-->
      <a-modal  dialogClass="custom-dialog" :maskClosable="false" v-model="salesAfterVisible" title="申请售后" @ok="actionSalesAfter"
               :width="600" :destroyOnClose="true" :disabled="$store.state.requestLoading">
        <a-form-model ref="formModel" layout="vertical" :model="actionSaleData"
                      :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item class="cu-item1" label="问题项" prop="question_item" style="margin-bottom: 0 !important"
                             :rules="{
                              required: true,
                              message: '请选择问题项',
                              trigger: 'change',
                            }"
          >
            <a-select v-model="actionSaleData.question_item" placeholder="请选择问题项" style="width: 100%"
                       @change="changeSalesList">
              <a-select-option v-for="(item, index) in tempData.currentList" :key="item.id">
                {{ item.problem_item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="hope_solution"  class="cu-item1"label="希望的解决方案" v-if="tempData.currentObject.open_solution == 'TRUE'"
                              :rules="{
                              required: true,
                              message: '请选择希望的解决方案',
                              trigger: 'change',
                            }"
          >
            <a-checkbox-group v-model="actionSaleData.hope_solution">
              <a-row style="padding-top: 8px">
                <a-col style="margin-bottom: 10px" :span="24" v-for="(item, index) in tempData.currentObject.solution_json">
                  <a-checkbox   :value="item.content">{{item.content}}</a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item class="cu-item1" label="问题类型" prop="question_type" style="margin-bottom: 0 !important"
                             :rules="{
                              required: true,
                              message: '请选择问题类型',
                              trigger: 'change',
                            }"
          >
            <a-select v-model="actionSaleData.question_type" placeholder="请选择问题类型" style="width: 100%"
                      @change="changeDescType">
              <a-select-option v-for="(item, index) in tempData.currentObject.type_description_json" :key="item.type">
                {{ item.type }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item class="cu-label" label="" prop="answer" v-if="actionSaleData.question_type"
                             :rules="{
                              required: true,
                              message: '请输入类型描述',
                              trigger: 'change',
                            }"
          >
            <a-textarea   v-model="actionSaleData.answer" style="height: auto !important;margin-left: 115px" :placeholder="actionSaleData.answer_placeholder" :rows="3" />
          </a-form-model-item>
          <a-form-model-item prop="abnormal_number" class="cu-item1" label="异常小鼠数" v-if="tempData.currentObject.open_abnormal_mice == 'TRUE'"
                             :rules="{
                              required: true,
                              message: '请填写异常小鼠数',
                              trigger: 'change',
                            }">
            <a-input-number v-model="actionSaleData.abnormal_number" placeholder="请填写异常小鼠数" style="width:200px"/>
          </a-form-model-item>
          <a-form-model-item class="cu-item1" label="上传附件">
            <file-upload @pictureChange="fileUrlChange" text.sync="上传附件" :img_url="actionSaleData.file_urls" :size="1"></file-upload>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<style>
.default {
  color: #666666 !important;
}
.total-g {
  border-right: none !important;
}
.column-box td {
  font-weight: bold;
}
.column-box td:first-child {
  border-left: none;
}
.column-box td:last-child {
  border-right: none;
}
.content-box td:first-child {
  border-left: none;
}
.content-box td:last-child {
  border-right: none;
}
.t-box {
  border: 1px solid #000;
  color: #000;
  margin-bottom: 20px;
  font-size: 12px;
}
.t-box .title {
  color: #000;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0 20px 0;
}
.order-box {
  margin: 20px 0 40px 0;
  margin-left: 10px;
  font-weight: bold;
  font-size: 14px;
}
.good-table {
  border-collapse: collapse;
}
.good-table td {
  border: 1px solid #000;
  text-align: center;
  padding: 5px;
}
.ml10 {
  margin-left: 10px;
}
.cu-table .ant-table-column-title {
  font-size: 12px !important;
}
.cu-table .ant-table-thead > tr > th, .cu-table .ant-table-tbody > tr > td {
  font-size: 12px !important;
}
.flex {
  display: flex;
}

.item-block {
  border: 1px solid #f5f5f5;
  padding: 10px;
  flex: 1;
}

.item-block-title {
  font-size: 12px;
  font-weight: bold;
  color: #00a0e9;
}

.mr5 {
  margin-right: 5px;
}

.ml5 {
  margin-left: 5px;
}

.mt10 {
  margin-top: 10px;
}

.label-item {
  line-height: 24px;
}

.bb {
  border-bottom: none;
}

.ml20 {
  margin-left: 20px;
}
.file-table .ant-table-column-title {
  font-size: 12px;
}
.detail-container {
  display: flex;
  font-size: 13px;
}
.detail-container-left {
  width: 100%;
  color: #000000 !important;

}
.detail-container-right {
  width: 330px;
  border-left: 1px solid #eeeeee;
  margin-left: 20px;
}
.product-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}
.product-table tr td {
  border: 1px solid #ddd;
  padding: 5px;
}
.product-table tr td.left {
  width: 200px;
}
.cu-div {
  border-color: #999999;
}
.mt10 {
  margin-top: 10px;
}

.mr10 {
  margin-right: 10px;
}

.label-item {
  line-height: 25px;
  border-bottom: 1px solid #f5f5f5;
  padding: 5px 0;
}

.label-title {
  font-weight: bold;
}

.label-info {
  color: #666666;
}

.label-title.ml10 {
  margin-left: 10px;
}
.cu-item1 {
  /*margin-bottom: 0 !important;*/
  padding-bottom: 0 !important;
}
</style>
<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';
import {getLookHealthReport, GetSalesAfterList, LookOutbound, OpenProgress, WxThenPay} from "./api";
import QRCode from "qrcodejs2";

export default {
  data() {

    return {
      actionSaleData: {
        question_item: undefined, // 问题项
        question_type: undefined, // 问题类型
        answer: '', // 问题答案
        answer_placeholder: '', // 问题答案描述
        file_urls: [], // 附件
        abnormal_number: '', // 异常数
        order_id: '', // 订单id
        good_json: [], // good_json
        hope_solution: undefined // 希望的解决方案
      },
      tempData: {
        currentList: [],
        currentObject: {}
      },
      salesTypeList: [],
      salesAfter: {},
      salesAfterVisible:false,
      salesAfterList: [],
      info_list: [],
      detailData: null,
      detailVisible: false,
      wxQrUrl: '',
      wxQrVisible: false,
      list: [],
      page: {
        start: 1,
        limit: 20,
        pageSize: 0,
        totalRow: 0,
        order_id: '',
        start_time: '',
        end_time: '',
        state: undefined,
        pay_state:  undefined
      },
      flag: false,
      filesColumns: [{
        title: "文件列表",
        dataIndex: "name",
        key: "name",
        slots: {
          customRender: 'name'
        },
      }],
      title: '商品订单',
      is_sale: 'FALSE',
      healthReportVisible: false,
      healthReportList: [],
      healthReportColumns: [
        {
          dataIndex: 'name',
          title: '健康报告',
          slots: { title: 'name' },
          scopedSlots: { customRender: 'name' },
        },
      ],
      lookOutboundList: [],
      lookOutboundVisible: false,
      visibleProgress: false,
      progressList: [],
      detailColumns: [{
        title: "品系编号",
        dataIndex: "strain_number",
        key: "strain_number",
        slots: {
          customRender: 'strain_number'
        },
        width:90,
        align:'center'
      }, {
        title: "品系名称",
        dataIndex: "common_name",
        key: "common_name",
        slots: {
          customRender: 'common_name'
        },
        width:90,
        align:'center'
      }, {
        title: "基因型",
        dataIndex: "gene",
        key: "gene",
        scopedSlots: {
          customRender: 'gene'
        },
        width:90,
        align:'center'
      }, {
        title: "周龄",
        dataIndex: "wks",
        key: "wks",
        scopedSlots: {
          customRender: 'wks'
        },
        width:70,
        align:'center'
      }, {
        title: "性别",
        dataIndex: "sex",
        key: "sex",
        slots: {
          customRender: 'order_id'
        },
        width:70,
        align:'center'
      }, {
        title: "数量",
        dataIndex: "num",
        key: "num",
        slots: {
          customRender: 'num'
        },
        width:50,
        align:'center'
      }, {
        title: "小计",
        dataIndex: "price",
        key: "price",
        slots: {
          customRender: 'price'
        },
        width:70,
        align:'center'
      }, {
        title: "包装方式",
        dataIndex: "ruleTip",
        key: "ruleTip",
        slots: {
          customRender: 'ruleTip'
        },
        width:80,
        align:'center'
      }],
      infoColumns: [
        {
          title: "到货时间",
          dataIndex: "delivery_time",
          key: "delivery_time",
          scopedSlots: {
            customRender: 'delivery_time'
          },
          width:100,
          align:'center'
        },
        {
          title: "运输方式",
          dataIndex: "transport_method",
          key: "transport_method",
          scopedSlots: {
            customRender: 'transport_method'
          },
          width: 100,
          align:'center'
        },
        {
          title: "运费",
          dataIndex: "freight",
          key: "freight",
          scopedSlots: {
            customRender: 'freight'
          },
          width:100,
          align:'center'
        },
        {
          title: "包装费",
          dataIndex: "packaging_fee",
          key: "packaging_fee",
          scopedSlots: {
            customRender: 'packaging_fee'
          },
          width:100,
          align:'center'
        },
        {
          title: "订单合计",
          dataIndex: "total_price",
          key: "total_price",
          scopedSlots: {
            customRender: 'total_price'
          },
          width:100,
          align:'center'
        },
        {
          title: "支付方式",
          dataIndex: "pay_type",
          key: "pay_type",
          scopedSlots: {
            customRender: 'pay_type'
          },
          width:100,
          align: 'center'
        },
        {
          title: "PO号",
          dataIndex: "noteid",
          key: "noteid",
          scopedSlots: {
            customRender: 'noteid'
          },
          align: 'center',
          width:100
        }
      ]
    };
  },
  create() {

  },
  mounted() {
    // let is_sale = window.localStorage.getItem('is_sale');
    // this.is_sale = is_sale;
    // if (is_sale == 'TRUE') {
    //   this.title = '代客商品订单';
    // }
    this.getSalesTypeList();
    this.getInfo();
    this.getList();
    if (this.$route.query && this.$route.query.id) {
      let intervalId = setInterval(()=>{
        let e = document.getElementById(this.$route.query.id);
        if (e) {
          clearInterval(intervalId)
          $('.children-module-content').animate({
            scrollTop: $('#'+ this.$route.query.id).offset().top
          }, 500);

        }
      },100)
    }
  },
  methods: {
    fileUrlChange(e) {
      this.actionSaleData.file_urls = e;
    },

    // 选择问题项
    changeSalesList(e) {
      let temp = this.tempData.currentList.filter(item=> item.id == e);
      this.tempData.currentObject = temp[0];
      this.tempData.currentObject.solution_json = JSON.parse(this.tempData.currentObject.solution_json);
      this.tempData.currentObject.type_description_json = JSON.parse(this.tempData.currentObject.type_description_json);
      this.actionSaleData.question_type = undefined;
      this.actionSaleData.answer = '';
      this.actionSaleData.abnormal_number = '';
      this.actionSaleData.answer_placeholder = '';
      this.actionSaleData.hope_solution = undefined;
    },
    // 选择问题类型
    changeDescType(e) {
      let temp = this.tempData.currentObject.type_description_json.filter(item => item.type == e);
      this.actionSaleData.answer_placeholder = temp[0]['describe'];
      this.actionSaleData.question_type = e;
    },
    async actionSalesAfter(e) {
      this.$refs.formModel.validate(async valid => {
        if (valid) {
          let temp = this.tempData.currentList.filter(item => item.id == this.actionSaleData.question_item);
          console.log(temp)
          if (temp.length > 0) {
            this.actionSaleData.question_item = temp[0]['problem_item'];
          }
          let res = await Api.SalesAfterSave(this.actionSaleData);
          if (res && res['code'] == '0') {
            this.$message.success(res.message);
            this.salesAfterVisible = false;
            this.getList();

            this. actionSaleData = {
              question_item: undefined, // 问题项
                  question_type: undefined, // 问题类型
                  answer: '', // 问题答案
                  answer_placeholder: '', // 问题答案描述
                  file_urls: [], // 附件
                  abnormal_number: '', // 异常数
                  order_id: '', // 订单id
                  good_json: [], // good_json
                  hope_solution: undefined // 希望的解决方案
            }
          } else {
            this.$message.error(res.message);
          }
        }
      });
    },

    // 打开售后框
    async openSalesAfter(item, good) {
      this.tempData.currentList = good.afterList;
      this.actionSaleData.order_id = item.id;
      this.actionSaleData.good_json = good;
      let temp = good.afterList.filter(a =>a.afterFlag == true);
      this.salesAfterList = temp;
      this.salesAfterVisible = true;
    },
    openDetail(id) {
      this.detailVisible = true;
      this.getDetail(id);
    },
    async getDetail(id) {
      this.info_list = [];
      this.detailData = null;
      let res = await Api.GetDetail({id: id});
      if (res && res.code == 0) {
        let item = Object.assign({}, res.target);
        item['address_json'] = JSON.parse(item['address_json'])
        item['bill_json'] = JSON.parse(item['bill_json'])
        let good_list = JSON.parse(item['good_list']);
        let temp = [];
        if (res.target.type == 'COMBINATION') {

          good_list.forEach(g=>{
            g.list.forEach((g1,index)=>{
              g1.packageList.forEach(t => {
                if (g1.packbox_id == t.id) {
                  g1['pack_name'] = t.value;
                }
              })
              if(index == 0) {
                g1['price'] = g['price'];
              } else {
                g1['price'] = '';

              }
              g1['strain_number'] = g['one_strain_number'] + '+' + g['two_strain_number']
              g1['common_name'] = g['one_common_name'] + '+' + g['two_common_name']
              temp.push(g1)
            })
          })
          item['good_list'] = temp;
        } else if (res.target.type == 'NORMAL') {
          item['good_list'] = JSON.parse(item['good_list'])
          item['good_list'].forEach(item => {
            item.packageList.forEach(t => {
              if (item.packbox_id == t.id) {
                item['pack_name'] = t.value;
              }
            })
          })
        }
        let delivery_time = '' ,transport_method = '';
        item['good_list'].forEach(good=> {

          if (good.transportModeList.length == 1) {
            good['transport_name'] = good.transportModeList[0]['name'];
          } else {
            let str = '';

            good.transportModeList.forEach(t=> {
              if (t.type_id == good.transport_id || t.id == good.transport_id) {
                str = t.name;
              }
            })

            if (str) {
              good['transport_name'] = str;
            } else {
              good.transportModeList.forEach(t=> {
                let type_id = good.deliveryTimeList[0]['type_id'];
                if (type_id == t.type_id) {
                  good['transport_name'] = t.name;
                }
              })
            }
          }
          delivery_time = good['delivery_time'];
          transport_method = good['transport_name'];
        });

        this.info_list.push({
          delivery_time: delivery_time,
          transport_method: transport_method,
          freight: item.freight,
          packaging_fee: item.packaging_fee,
          total_price: item.total_price,
          pay_type: item.pay_type,
          noteid: ''
        });
        item['license'] = JSON.parse(item['license'])
        item['logistics'] = [];

        if (item.files != null) {
          try {
            let temp = JSON.parse(item.files);
            let state = item.file_state == 'TRUE' ? '客户已确认' : '客户未确认';
            let tempArr = [];
            temp.forEach(item=>{
              tempArr.push({name: item, state: state})
            })
            item.files = tempArr;
          } catch (e) {

          }
        }
        this.detailData = item;
      }
    },
    closeDetail() {
      this.detailVisible = false;
    },
    // 项目进展
    async openProgress(id) {
      let res = await Api.OpenProgress({id: id});
      if (res && res.code == 0) {
        this.visibleProgress = true;
        this.progressList = res.list;
      }
    },
    closeProgress() {
      this.visibleProgress = false;
    },
    async getInfo() {
      let res = await Api.GetUserInfo({});
      if (res && res.code == 0) {
        this.is_sale = res.user.is_sale;
        if (this.is_sale == 'TRUE') {
          this.title = '代客商品订单';
        }
      }
    },

    againOrder(good) {
      this.getOrderSku(good.good_list,good.id);
    },
    againOrderC(item) {
      let cartList = window.localStorage.getItem('combinationCartList');
      cartList = JSON.parse(cartList)
      let token = window.localStorage.getItem('token');
      let userid = window.localStorage.getItem('userid');
      for(let i = 0; i < cartList.length; i++) {
        if (cartList[i]['userid'] == userid) {
          cartList[i]['list'] = [...cartList[i]['list'], ...item.good_list_c];
          console.log(cartList[i]['list'])
          window.localStorage.setItem('combinationCartList', JSON.stringify(cartList));
          window.location.href = '/shop/combination.html';
          break;
        }
      }
    },

    // 支付宝支付订单
    async alipayThenPay(id) {
      let res = await Api.AlipayThenPay({id: id});
      if (res && res["code"] == "0") {
        const div = document.createElement('div')
        div.innerHTML = res.response
        document.body.appendChild(div)
        console.log(document.forms.length)
        document.forms[document.forms.length - 1].submit()
        // document.forms[0].submit()
      }
    },

    // 微信支付
    async wxThenPay(id) {
      let res = await Api.WxThenPay({id: id});
      if (res && res.code == "wx") {
        if (res && res.code_url) {
          this.wxQrUrl = res.code_url;
          this.wxQrVisible = true;
          this.$nextTick(() => {
            this.qrcode()
          })

        } else {
          this.$message.error('微信支付调用失败');
        }
      }
    },

    // 打开取消订单框
    async openCancel(id) {
      let that = this;
      this.$confirm({
        title: '操作提示',
        content: '您确定要取消订单吗?',
        async onOk() {
          let res = await Api.Del({id: id});
          if (res && res["code"] == "0") {
            that.$message.success('取消成功');
            that.getList();
          }
        },
        onCancel() {},
      });
    },

    // 搜索
    search() {
      this.getList();
    },

    // 重置
    resetForm() {
      this.page.order_id = '';
      this.page.state = undefined;
      this.page.start_time = '';
      this.page.end_time = '';
    },

    // 时间
    changeTime(e, s) {
      this.start_time = s[0];
      this.end_time = s[1];
    },
    // 售后问题列表
    async getSalesTypeList() {
      let res = await Api.GetSalesAfterList({});
      if (res && res.code == 0) {
        res.list.forEach(item=>{
          if (item['type_ids']) {
            item.type_ids = item['type_ids'].split(',');
          } else {
            item['type_ids'] = [];
          }
        })
        this.salesTypeList = res.list;
      }
    },
    // 获取列表
    async getList() {
      let res = await Api.GetList(this.page);
      if (res && res["code"] == "0") {
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
        res.page.list.forEach((item, index)=>{
          item['good_list'] = JSON.parse(item['good_list']);
          // 售后逻辑
          let temp  = JSON.stringify(this.salesTypeList);
          temp = JSON.parse(temp)
          item['good_list'].forEach(good=>{
            // 当前订单的状态
            if (item['state'] == 'RECEIVED' || item['state'] == 'OVER') {
              if (good['typeIds']) {
                let tempTypeIds = good['typeIds'].split(',');
                good['salesAfter'] = false;

                temp.forEach((s, i)=>{
                  // 交集
                  s['afterFlag'] = false;
                  let ids = tempTypeIds.filter(t=>s.type_ids.indexOf(t) > -1);
                  let delivery_time = new Date(good.delivery_time + " 23:59:59"); // 收货时间
                  let feedback_timeliness = s.feedback_timeliness; // 反馈时效
                  delivery_time = delivery_time.setDate(delivery_time.getDate() + parseInt(feedback_timeliness)); // 售后有效期
                  delivery_time = new Date(delivery_time).getTime();
                  let current_time = new Date().getTime();

                  if (ids.length > 0 && delivery_time >= current_time) { // 有品系，时间有效
                    // console.log("ids ", ids);
                    // console.log("delivery_time >= current_time ", delivery_time >= current_time);
                    s['afterFlag'] = true;
                  }
                });

                // console.log(this.salesTypeList)

                // console.log(temp)
                let temp2 = temp.filter(item=>item.afterFlag == true);
                if (temp2.length > 0) {
                  // console.log('111')
                  good['salesAfter'] = true;
                  good['afterList'] = temp2;
                }
                // console.log(good)
              }
            }
          })
          item['address_json'] = JSON.parse(item['address_json']);
        })

        res.page.list.forEach(item=>{
          item['good_list_c'] = item['good_list'];
          if (item.type == 'NORMAL') {
            let good_list = item['good_list'];
            good_list.forEach(g=>{
              let packbox_id = g['packbox_id'];
              let transport_id = g['transport_id'];

              g.transportModeList.forEach(t=>{
                if (t.id == transport_id) {
                  item['transport_name'] = t.name;
                }
              })

              g.packageList.forEach(p=>{
                if (p.id == packbox_id) {
                  item['pack_name'] = p.value;
                }
              })

            })
            item['good_list'] = good_list;
          } else if (item.type == 'COMBINATION') {
            console.log(item['good_list'])
            let good_list = item['good_list'];
            let temp = [];
            good_list.forEach(g=>{
              g.list.forEach((g1,index)=>{
                g1.transportModeList.forEach(t => {
                  if (g1.transport_id == t.type_id) {
                    g1['transport_name'] = t.name;
                  }
                })
                g1.packageList.forEach(t => {
                  if (g1.packbox_id == t.id) {
                    g1['pack_name'] = t.value;
                  }
                })
                if(index == 0) {
                  g1['price'] = g['price'];
                } else {
                  g1['price'] = '';

                }
                g1['strain_number'] = g['one_strain_number'] + '+' + g['two_strain_number']
                g1['common_name'] = g['one_common_name'] + '+' + g['two_common_name']
                temp.push(g1)
              })
            })
            item['good_list'] = temp;
          }


          if (item.files != null) {
            try {
              let temp = JSON.parse(item.files);
              let tempArr = [];
              temp.forEach(item=>{
                tempArr.push({name: item})
              })
              item.files = tempArr;
            } catch (e) {

            }
          }

        })
        this.list = res.page.list;
        this.flag = true;
      }
    },
    // 改变分页
    changePage(e) {
      this.page.start = e;
      this.getList();
    },
    // 生成二维码
    qrcode() {
      new QRCode('qrcode', {
        text: this.wxQrUrl,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
      });
    },
    wxPay() {
      this.wxQrVisible = false;
      this.wxQrUrl = '';
      this.getList();
    },
    async fileConfirmation(item) {
      let res = await Api.FileConfirmation({id: item.id});
      if (res && res["code"] == "0") {
        this.$message.success(res.message);
        this.getList();
      }
    },
    // 再来一单的sku
    async getOrderSku(list, id) {
      let res = await Api.GetOrderSku({id: id, type:'normal'});
      if (res && res["code"] == "0") {
        res.store.forEach((item,index)=> {
          list[index]['age_json'] = JSON.parse(item.target['age_json']);
          list[index]['gene_json'] = JSON.parse(item.target['gene_json']);
          list[index]['sex_json'] = JSON.parse(item.target['sex_json']);
          list[index]['state_json'] = JSON.parse(item.target['state_json']);
          list[index]['priceList'] = item.priceList;
          list[index]['add_time'] =  new Date();
        })

        let cartList = window.localStorage.getItem('cartList');
        let token = window.localStorage.getItem('token');
        let userid = window.localStorage.getItem('userid');


        // 根据 token 获取购物车信息
        if (token && cartList) {
          let tempCartList = JSON.parse(cartList);
          let temp = [];
          tempCartList.forEach(item => {
            if (item.userid == userid) {
              temp = [...item.list, ...list];
              item.list = temp;
            }
          });
          // console.log(tempCartList)
          window.localStorage.setItem('cartList', JSON.stringify(tempCartList));
          window.location.href = '/shop/cart.html';
        }
      }
    },
    // 查看健康报告
    async openHealthReport(id){
      let res = await Api.GetLookHealthReport({id: id});
      if (res && res.code == 0) {
        this.healthReportVisible = true;
        let temp = [];
        res.list.forEach(item=>{
          temp.push({name: item})
        })
        this.healthReportList= temp;
      }
    },
    // 查看出库单
    async openLookOutbound(id){
      let res = await Api.LookOutbound({id: id});
      if (res && res.code == 0) {
        if (res.target.length == 0) {
          this.$message.error('暂无出库单信息');
          return;
        }
        this.lookOutboundVisible = true;
        res.target.forEach(item=>{
          let dtotal = 0;
          item.documentManageVos.forEach(g=>{
            g['dprice'] = (Number(g.quantity) * Number(g.micePrice)).toFixed(2)
            dtotal += Number(g['dprice'])
          })
          item['dtotal'] = Number(dtotal).toFixed(2)
        })
        this.lookOutboundList = res.target;
      }
    }
  },
};
</script>

<style lang="less">
  .cu-btn {
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 30px;
    padding: 0 25px;
  }
.tips-text {
  font-size: 14px;
  font-weight: 500;
  color: #007F76;
  line-height: 38px;
  padding-top: 2px;
}

.children-module-content {
  padding: 25px !important;
}

.list {
  border: 1px solid #ECECEC;
  padding: 30px;
  display: flex;
  align-items: center;
}

.list .label {
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin-right: 10px;
}

.list .info {
  flex: 1;
}

.list .action {
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: flex-end
}

.list .default {
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  color: #008276;
  line-height: 30px;
  margin-left: 10px;
}

.list .name {
  font-size: 12px;
  color: #999999;
  line-height: 30px;
}

.inner-item {
  line-height: 20px;
}

.company-list {
  border: 1px solid #eee;
  font-size: 12px;
  overflow-y: scroll;
  max-height: 300px;
  position: absolute;
  background-color: #fff;
  z-index: 99999;
  width: 100%;
  font-weight: 600;
}

.company-item {
  line-height: 40px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
}

.company-list .company-item:hover {
  cursor: pointer;
  background: #F2F8F8;
}

.company-list .company-item:last-child {
  border-bottom: none;
}
  .file-table .ant-table-column-title {
    font-size: 12px;
  }
  .file-list a {
    display: block;
  }
  .cu-label .ant-form-explain {
    margin-left: 115px;
  }
</style>

